import { useTranslation } from "react-i18next";
import Modal from "../../../../parts/modal-new";
import submit from "submit-form";
import SvgIcon from "../../../../parts/SvgIcon";

const CALENDAR_PREVIEW_DAYS = [
  { date: "Jan 5, 2026", dayLabel: "Day 1" },
  { date: "Jan 6, 2026", dayLabel: "Day 2" },
  { date: "Jan 7, 2026", dayLabel: "Day 3" },
];

const MenstrualCycleEnabled = ({ locals }) => {
  const { t } = useTranslation("athlete-portal");
  const clientName = locals?.athlete?.name ?? "your client";

  return (
    <Modal
      className="menstrual-cycle-enabled-modal"
      header={false}
      toClear={[]}
    >
      <div className="menstrual-cycle-enabled-modal__body">
        <div className="menstrual-cycle-enabled-modal__success-icon">
          <img
            src="/img/new-icons/vuesax-linear-tick-no-background.svg"
            alt=""
            aria-hidden
          />
        </div>
        <h3 className="menstrual-cycle-enabled-modal__title">
          {t("menstrualCycleEnabled.title")}
        </h3>
        <p className="p2">
          {t("menstrualCycleEnabled.successMessage", { clientName })}
        </p>

        <div className="menstrual-cycle-enabled-modal__divider"></div>

        <div className="menstrual-cycle-enabled-modal__info">
          <div className="menstrual-cycle-enabled-modal__info-item">
            <div className="menstrual-cycle-enabled-modal__info-icon">
              <SvgIcon src="/img/new-icons/person-circle-outline.svg" />
            </div>
            <div className="gap-1 flex flex-col">
              <strong>{t("menstrualCycleEnabled.clientInitiatedTitle")}</strong>
              <p className="p6">
                {t("menstrualCycleEnabled.clientInitiatedDesc")}
              </p>
            </div>
          </div>
          <div className="menstrual-cycle-enabled-modal__info-item">
            <div className="menstrual-cycle-enabled-modal__info-icon">
              <SvgIcon src="/img/new-icons/calendar.svg" />
            </div>
            <div className="gap-1 flex flex-col">
              <strong>{t("menstrualCycleEnabled.calendarIntegrationTitle")}</strong>
              <p className="p6">
                {t("menstrualCycleEnabled.calendarIntegrationDesc")}
              </p>
            </div>
          </div>
          <div className="menstrual-cycle-enabled-modal__info-item">
            <div className="menstrual-cycle-enabled-modal__info-icon">
              <SvgIcon src="/img/new-icons/stats-chart.svg" />
            </div>
            <div className="gap-1 flex flex-col">
              <strong>{t("menstrualCycleEnabled.predictiveInsightsTitle")}</strong>
              <p className="p6">
                {t("menstrualCycleEnabled.predictiveInsightsDesc")}
              </p>
            </div>
          </div>
        </div>

        <div className="menstrual-cycle-enabled-modal__preview">
          <p className="p2 mb-3">{t("menstrualCycleEnabled.calendarPreview")}</p>
          <div className="menstrual-cycle-enabled-modal__preview-cards">
            {CALENDAR_PREVIEW_DAYS.map(({ date, dayLabel }) => (
              <div
                key={date}
                className="menstrual-cycle-enabled-modal__preview-card"
              >
                <div className="menstrual-cycle-enabled-modal__preview-date-wrapper">
                  <div className="menstrual-cycle-enabled-modal__preview-date-icon"></div>
                  <p className="menstrual-cycle-enabled-modal__preview-date">
                    {date}
                  </p>
                </div>
                <span className="menstrual-cycle-enabled-modal__preview-badge">
                  {dayLabel} - {t("femaleCycleIndicator.title")}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <footer id="confirmation-modal-footer">
        <button
          type="button"
          data-button-type="primary"
          onClick={() => {
            submit("/actions/refresh?", {
              method: "GET",
              body: { "modal[type]": "" },
            });
          }}
        >
          <span>{t("menstrualCycleEnabled.gotIt")}</span>
        </button>
      </footer>
    </Modal>
  );
};

export default MenstrualCycleEnabled;
